/* eslint-disable */
import generateStoreSetters from '@/helpers/generateStoreSetters';
import { State, StateNomenclature } from './state';

const state = new State();

const store = {
  namespaced: true,
  state,
  mutations: {
    ...generateStoreSetters(state),
    clearState: (stateNomenclature: StateNomenclature): void => {}
  },
  actions: {},
  modules: {},
  getters: {}
};

export { store as nomenclature };
